import { SceneSetters } from "../../types";
import GameScene from "./GameScene";
import EndScene from "./EndScene";
import TitleScene from "./TitleScene";

export function generateScenes(setters: SceneSetters): Phaser.Scene[] {
  return [TitleScene, GameScene, EndScene].map((Scene) => new Scene(setters));
}
